<template lang="pug">
label.v-field-checkbox.field-checkbox(:class="{'field-checkbox--radio': radio, 'field-checkbox--disabled': disabled, 'field-checkbox--sm': size === 'sm', 'field-checkbox--centered': centered, 'field-checkbox--flex': showUsername, 'field-checkbox--multiple': field?.multiple, 'field-checkbox--editable': field?.editable, 'field-checkbox--has-availability': field && field.availability}")
	.field-checkbox__input-wrap
		template(v-if="editable")
			input.field-checkbox__input(ref="editable-checkbox" :type="radio ? 'radio' : 'checkbox'"
					:value="localTrueValue"
					v-model="localValue"
					@change="handleInput"
					:disabled="disabled || !fieldInputText"
					:aria-labelledby="(labelId ? labelId + ' ' + uniqueId : null)"
					:id="uniqueId")
		template(v-else)
			input.field-checkbox__input(:type="radio ? 'radio' : 'checkbox'"
					:value="trueValue"
					v-model="localValue"
					@change="handleInput"
					:disabled="disabled"
					:aria-labelledby="(labelId ? labelId + ' ' + uniqueId : null)"
					:id="uniqueId")
		span.field-checkbox__visual
		template(v-if="editable")
			span.field-checkbox__text(v-if="fieldInputText") {{fieldInputText}}
		template(v-else)
			span.field-checkbox__note(v-if="note || field?.note" v-html="note || field?.note")
			template(v-if="description")
				.field-checkbox__text-wrap
					span.field-checkbox__text(v-html="text || field?.label")
					.field-checkbox__description(v-if="description" v-html="description")
			template(v-else)
				span.field-checkbox__text(v-html="text || field?.label")
		template(v-if="quantity")
			span.field-checkbox__quantity(v-if="quantity" v-html="quantity")
		template(v-if="field && field.editable && editable && !fieldInputText")
			.field-checkbox__field-input
				input.field-input.field-input--simple-2(type="text"
						inputmode="text"
						:disabled="field ? field.disabled : disabled"
						v-model="fieldInputValue"
						:placeholder="placeholder"
						autocomplete="off")
				button.field-checkbox__field-input-btn(type="button" @click.stop="apply" :disabled="!fieldInputValue") Готово
</template>

<script>
import uniqueId from '../scripts/helpers/uniqueId.js';
import {mapGetters} from 'vuex';

export default {
	props: {
		field: {
			type: Object,
			default: null
		},

		radio: {
			type: Boolean,
			default: false
		},

		note: {
			type: [String, Number],
			default: null
		},

		text: {
			type: [String, Number],
			default: null
		},

		description: {
			type: [String, Number],
			default: null
		},

		modelValue: {
			type: [Object, String, Number, Boolean],
			default: null
		},

		trueValue: {
			type: [Object, String, Number, Boolean],
			default: null
		},

		disabled: {
			type: Boolean,
			default: false
		},

		labelId: {
			type: String,
			default: null
		},

		quantity: {
			type: [Number, String],
			default: null
		},

		size: {
			type: String,
			default: null
		},

		centered: {
			type: Boolean,
			default: false
		},

		label: {
			type: String,
			default: null
		},

		showUsername: {
			type: Boolean,
			default: false
		},

		editable: {
			type: Boolean,
			default: false
		},

		placeholder: {
			type: String,
			default: null
		},

		defaultText: {
			type: String,
			default: null
		}
	},

	emits: [
		'update:model-value'
	],

	data() {
		return {
			localValue: null,
			open: false,
			uniqueId: uniqueId('field-'),
			fieldInput: false,
			fieldInputText: null,
			fieldInputValue: null,
			localTrueValue: ''
		};
	},

	watch: {
		modelValue() {
			this.updateLocalValue();
		}
	},

	created() {
		this.fieldInputValue = this.defaultText;
		this.updateLocalValue();
	},

	methods: {
		apply() {
			this.localTrueValue = this.fieldInputText = this.fieldInputValue;
			this.$refs['editable-checkbox'].checked = true;
		},

		updateLocalValue() {
			this.localValue = this.modelValue;
		},

		handleInput() {
			this.$emit('update:model-value', this.localValue);
		}
	}
};
</script>
